import { resolveTransferPopupCopy } from "@frontend-shared/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { ITransferPopupCopy, IUseTransferPopupCopyProps } from "../types";

// NOTE: NSAI-7067 — every word the card prints, resolved from the shared
// helpers so the mobile card reads the same about the same transfer. Kept out
// of the card itself so the component is layout only.
export const useTransferPopupCopy = ({
  primary,
  selection,
  now,
}: IUseTransferPopupCopyProps): ITransferPopupCopy => {
  const { t } = useTranslation("uploads");

  return useMemo(() => {
    const { closeLabel, ...copy } = resolveTransferPopupCopy({
      primary,
      inFlightCount: selection.inFlightCount,
      now,
      translate: (key, options) => t(key, options),
    });

    return {
      ...copy,
      closeAriaLabel: closeLabel,
    };
  }, [primary, selection.inFlightCount, now, t]);
};
